export class Links {
    self?: string;
    related?: {
        href: string;
        meta: object;
    };
}